<template>
  <div>
    <section class="page-hero" :style="{ '--ph-img': `url(${images.hero4})` }">
      <div class="wrap">
        <p class="eyebrow reveal">Featured work</p>
        <h1 class="reveal">Our interior design projects</h1>
        <p class="reveal">A selection of Singapore homes we've crafted, each one shaped around the people who live in it.</p>
        <p class="crumb reveal"><router-link to="/">Home</router-link> · Projects</p>
      </div>
    </section>

    <article
      v-for="(p, i) in projects"
      :key="p.slug"
      class="section"
      :class="{ tint: i % 2 === 1 }"
    >
      <div class="wrap">
        <header class="proj-intro reveal">
          <p class="eyebrow">{{ p.category }}</p>
          <h2>{{ p.name }}</h2>
          <p class="proj-summary">{{ p.summary }}</p>
        </header>

        <section v-for="s in p.sections" :key="s.title" class="proj-section">
          <div class="proj-copy reveal">
            <h3>{{ s.title }}</h3>
            <p v-if="s.lead" class="proj-lead">{{ s.lead }}</p>
            <p v-if="s.body" class="proj-body">{{ s.body }}</p>
          </div>

          <!-- Short preview: first two photos. The rest live in the lightbox. -->
          <div class="proj-shots">
            <figure
              v-for="(src, n) in s.images.slice(0, 2)"
              :key="n"
              class="proj-shot reveal"
              @click="openLightbox(p, s, n)"
            >
              <img :src="src" :alt="`${p.name} — ${s.title}`" loading="lazy" />
              <!-- Overlay the remaining count on the 2nd tile -->
              <figcaption v-if="n === 1 && s.images.length > 2" class="proj-more">
                +{{ s.images.length - 2 }} more
              </figcaption>
            </figure>
          </div>

          <div v-if="s.images.length > 2" class="proj-viewall reveal">
            <button type="button" class="btn btn-dark" @click="openLightbox(p, s, 0)">
              View all {{ s.images.length }} photos
            </button>
          </div>
        </section>
      </div>
    </article>

    <ImageLightbox
      :open="lb.open"
      :images="lb.images"
      :title="lb.title"
      :start="lb.start"
      @close="lb.open = false"
    />

    <section class="band" :style="{ '--band-img': `url(${images.diningDarkOak})` }">
      <div class="wrap reveal">
        <blockquote>Every home tells a quieter kind of story.</blockquote>
        <cite>EIKA Interiors</cite>
      </div>
    </section>

    <section class="section tint" style="text-align: center">
      <div class="wrap reveal">
        <p class="eyebrow">Like what you see?</p>
        <h2 style="font-size: clamp(2rem, 4vw, 3.2rem); margin: 1rem 0 1.4rem">Yours could be the next one we craft.</h2>
        <router-link to="/contact" class="btn btn-primary">Start a project</router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { projects, images } from "@/data/projects";
import ImageLightbox from "@/components/ImageLightbox.vue";

export default {
  name: "ProjectsView",
  components: { ImageLightbox },
  data() {
    return {
      projects,
      images,
      lb: { open: false, images: [], title: "", start: 0 },
    };
  },
  methods: {
    openLightbox(project, section, start) {
      this.lb = {
        open: true,
        images: section.images,
        title: `${project.name} · ${section.title}`,
        start,
      };
    },
  },
};
</script>
